import React, { Component } from "react"
import BaseModal, { ModalActions, SaveButton, CancelButton } from "../../../../containers/UI/Modal/BaseModal";
import SelectRow from "../../../configuration/Rows/SelectRow/SelectRow"


class FilterModal extends Component {

  state = {
    category: "all-categories",
  }
  allCategories = { label: "All categories", value: "all-categories" }

  componentDidMount() {
    if (this.props.filteredCategory !== "") {
      this.setState({ category: this.props.filteredCategory })
    }
  }

  
  render() {

    return (
      <BaseModal 
        isOpen={this.props.shouldShow} 
        onClose={this.props.closeModal}
        title="Filter stock overview"
      >
        <SelectRow
          title="Show stock for"
          firstRow
          ultrawide
          defaultValue={"all-categories"}
          value={this.state.category}
          onChange={(newValue) => this.setState({ category: newValue.value })}
          options={[this.allCategories, ...this.props.categoryOptions]}/>

        <ModalActions>
          <CancelButton onClick={this.props.closeModal}/>
          <SaveButton onClick={() => { this.props.applyFilter(this.state.category); this.props.closeModal() }}>
            Apply
          </SaveButton>
        </ModalActions>
      </BaseModal>
    )
  }
}


export default FilterModal;
